import { setChallenge } from "@/modules/auth/state";
import { AppPaths, Challenge, Storage } from "@/shared/common/enums";
import { AuthHeader, Footer } from "@/shared/components";
import { useAppDispatch, useTrackPageView } from "@/shared/hooks";
import { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";

export const AuthLayout = () => {
  useTrackPageView();
  const dispatch = useAppDispatch();
  const isAuth = localStorage.getItem(Storage.IsAuth);

  useEffect(() => {
    return () => {
      dispatch(setChallenge(Challenge.Empty));
    };
  }, []);

  if (isAuth) {
    return <Navigate to={AppPaths.Dashboard} replace/>;
  }

  return (
    <div className="auth-layout">
      <AuthHeader/>
      <div className="auth-layout--container">
        <Outlet/>
      </div>
      <Footer/>
    </div>
  );
};
